import React, { useState } from 'react';
import { Section, FadeIn } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Y si yo soy caso perdido?',
    a: 'No. Eres caso humano. El sistema no depende de "motivación", depende de diseño y fricción.'
  }, {
    q: '¿Tengo que dejar de comprar?',
    a: 'No. Solo tienes que dejar de comprar en ROJO. El resto se ordena solo con el sistema.'
  }, {
    q: '¿Y si recaigo?',
    a: 'Viene un protocolo de caída. La recaída no es el final; es un dato para ajustar tu sistema.'
  }];
  return <Section background="warm" data-id="element-35">
      <FadeIn data-id="element-36">
        <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-12 text-center" data-id="element-37">
          Preguntas que tu mente va a hacer
        </h2>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-38">
        {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-39">
            <FAQItem question={faq.q} answer={faq.a} data-id="element-40" />
          </FadeIn>)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white/80 backdrop-blur-sm rounded-lg border border-[#E8D5DC] overflow-hidden" data-id="element-41">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-42">
        <span className="font-serif text-lg text-[#3D1F2E] font-medium" data-id="element-43">
          {question}
        </span>
        {isOpen ? <ChevronUp className="text-[#C4467E]" data-id="element-44" /> : <ChevronDown className="text-[#7A5C6B]" data-id="element-45" />}
      </button>
      <AnimatePresence data-id="element-46">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-47">
            <div className="px-6 pb-6 text-[#7A5C6B]" data-id="element-48">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}